// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`TwitterImage test Match con el snapshot 1`] = `
<a target="_blank" href="https://twitter.com/bbva_argentina"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="26" viewBox="0 0 26 26">
        <defs>
            <path id="a-twitter" d="M1 13C1 6.373 6.373 1 13 1s12 5.373 12 12-5.373 12-12 12S1 19.627 1 13zm17.973-2.841a6.412 6.412 0 0 0 1.545-1.48 6.549 6.549 0 0 1-1.775.443 2.89 2.89 0 0 0 1.354-1.575 6.362 6.362 0 0 1-1.958.69 3.197 3.197 0 0 0-2.255-.902c-1.706 0-3.087 1.283-3.087 2.858 0 .222.016.443.065.656-2.558-.124-4.863-1.257-6.38-2.993-.267.426-.468.913-.468 1.444 0 .991.446 1.868 1.275 2.381-.505-.018-1.589-.15-1.589-.364v.037c0 1.39 1.255 2.54 2.666 2.805-.257.062-.337.098-.614.098-.2 0-.391-.018-.582-.045.391 1.133 1.526 1.956 2.88 1.983a6.478 6.478 0 0 1-3.825 1.222c-.257 0-.496-.009-.744-.036a9.209 9.209 0 0 0 4.733 1.284c5.668 0 8.768-4.355 8.768-8.135 0-.124 0-.248-.009-.371z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <path d="M0 0h26v26H0z"></path>
            <mask id="b-twitter" fill="#5BBEFF">
                <use xlink:href="#a-twitter"></use>
            </mask>
            <use fill="#5BBEFF" xlink:href="#a-twitter" class="hover--icon"></use>
            <g fill="#5BBEFF" mask="url(#b-twitter)">
                <path d="M0 0h26v26H0z" class="hover--icon"></path>
            </g>
        </g>
    </svg></a>
`;
